export default __webpack_public_path__ + "static/media/038-soda.2bf83fb1.svg";